import { message, Button } from 'antd';
import { func } from 'prop-types';
import Swal from 'sweetalert2'
let adConfirmMsg="هزینه ی آگهی شما به میزان تعرفه ی جستجو افزایش یافت آگهی شما به مدت یک ماه توسط ما در سامانه ی پست یافته جستجو خواهد شد و در صورت پیدا شدن به شماره موبایل شما اطلاع رسانی خواهد شد"
let adConfirmMsg2="شما گزینه ی درخواست جستجو را انتخاب نکردید در صورت انتخاب این گزینه به مدت یک ماه در سامانه ی پست یافته آگهی شما جستجو خواهد شد و همچنین مبلغی به میزان هزینه ی جستجو به آگهی شما افزوده خواهد شدآیا مایل به درخواست جستجو هستید؟"

export async function ShowError(subject, contetn) {

    let sub = subject ?? "خطا";
    let contet = contetn ?? "در انجام عملیات خطایی به وجود آمد";
    Swal.fire({
        title: sub,
        text: contet,
        icon: 'error'
    })

}
export async function ShowSmallError(subject) {
   console.log('////////////////')
   //console.log(subject);
   if(subject!=undefined&&subject!=null){message.error(subject);}
     console.log('////////////////')
}

export async function TimerClsoe(subject, contetn) {
    let sub = subject ?? "انجام عملیات";
    let contet = contetn ?? "عملیات با موفقیت انجام شد";
    let timerInterval
    Swal.fire({
        title: sub,
        html: 'درحال انتقال به درگاه <b></b> میلی ثانیه.',
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft()
            }, 100)
        },
        willClose: () => {
            clearInterval(timerInterval)
        }
    }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
            console.log('I was closed by the timer')
        }
    })
}
export async function ShowSuccess(subject, contetn) {
    let sub = subject ?? "انجام عملیات";
    let contet = contetn ?? "عملیات با موفقیت انجام شد";
    Swal.fire({
        title: sub,
        text: contet,
        icon: 'success'
    })

}
export async function ShowConfirm(subject, contetn, callBack, canCelCallBack) {
    let sub = subject ?? "انجام عملیات";
    let contet = contetn ?? "عملیات با موفقیت انجام شد";
    Swal.fire({
        title: sub,
        text: contet,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله اطلاعات صحیح است',
        cancelButtonText: 'انصراف',
        denyButtonText: 'انصراف'
    }).then((result) => {
        if (result.isConfirmed) {
            callBack();
        } else if (canCelCallBack) {
            canCelCallBack();
        }
    })

}
export async function ShowDeleteConfirm(subject, contetn, callBack, canCelCallBack) {
    let sub = subject ?? "انجام عملیات";
    let contet = contetn ?? "عملیات با موفقیت انجام شد";
    Swal.fire({
        title: sub,
        text: contet,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله',
        cancelButtonText: 'انصراف',
        denyButtonText: 'انصراف'
    }).then((result) => {
        if (result.isConfirmed) {
            callBack();
        } else if (canCelCallBack) {
            canCelCallBack();
        }
    })

}

export async function ShowAdConfirm(subject, contetn, callBack, canCelCallBack,searchRequest) {
    let sub = subject ?? "انجام عملیات";
    //alert(searchRequest);
    let contet =searchRequest?(contetn ?? "عملیات با موفقیت انجام شد")+' ! توجه ! '+adConfirmMsg:(contetn ?? "عملیات با موفقیت انجام شد")+' ! توجه ! '+adConfirmMsg2;
    Swal.fire({
        title: sub,
        text: contet,
        icon: 'warning',
        showCancelButton: true,
        showDenyButton:searchRequest?false:true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        denyButtonColor:'#ffcf17',
        confirmButtonText: 'تایید و درخواست جستجو',
        cancelButtonText: 'انصراف',
        denyButtonText: 'تایید و عدم درخواست جستجو'
    }).then((result) => {
        if (result.isConfirmed) {
            callBack(true);
        } else if (result.isDenied) {
            callBack(false);
        }else if (canCelCallBack) {
            canCelCallBack();
        }
    })

}